import { render } from "./CropperImg.vue?vue&type=template&id=088d1340&scoped=true"
import script from "./CropperImg.vue?vue&type=script&lang=js"
export * from "./CropperImg.vue?vue&type=script&lang=js"

import "./CropperImg.vue?vue&type=style&index=0&id=088d1340&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-088d1340"]])

export default __exports__